import { render } from "./Start.vue?vue&type=template&id=38706cbe&scoped=true&ts=true"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"

import "./Start.vue?vue&type=style&index=0&id=38706cbe&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38706cbe"]])

export default __exports__